import { render, staticRenderFns } from "./tailored.vue?vue&type=template&id=b4f55f18"
import script from "./tailored.vue?vue&type=script&lang=js"
export * from "./tailored.vue?vue&type=script&lang=js"
import style0 from "./tailored.vue?vue&type=style&index=0&id=b4f55f18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports